import AuthForm from '../components/Auth/AuthForm';

const AuthPage: React.FC = () => {
  return <AuthForm />;
};

export default AuthPage;
